import { Button } from '@edsn/pie-components';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { Card } from '#pie/components/card/Card';
import { CopyButton } from '#pie/components/copy-button/CopyButton';
import { Page, PageHeader } from '#pie/components/page/Page';
import { PageHead } from '#pie/components/page-head/PageHead';
import { Stack } from '#pie/components/stack/Stack';
import { Text } from '#pie/components/text/Text';

export const Ideas = () => {
  const { t } = useTranslation();
  const { t: thl } = useTranslation('hyperlinks');

  return (
    <>
      <PageHead title={t('ideas.title')} />
      <Page>
        <PageHeader title={t('ideas.title')} />
        <Stack className="mx-auto my-6 max-w-4xl">
          <Card
            size="md"
            heading={
              <Text as="h2" variant="h5">
                {t('ideas.new.title')}
              </Text>
            }
          >
            <Stack gap="md" className="mb-6">
              <Stack gap="sm">
                <Text>{t('ideas.new.description.part_1')}</Text>
                <Text>{t('ideas.new.description.part_2')}</Text>
              </Stack>
              <div className="flex flex-direction-row gap-4">
                <Button
                  as="a"
                  action="secondary"
                  emphasis="subtle"
                  href={thl('ideas.overview')}
                  className="size-fit"
                  target="_blank"
                >
                  {t('ideas.view.submitted.ideas.description.button')}
                </Button>
                <Button
                  as="a"
                  action="secondary"
                  emphasis="bold"
                  href="mailto:info@partnersinenergie.nl?subject=Idee/suggestie&body=Beste Team Partners in Energie,%0D%0A%0D%0AVia deze weg wil ik een verbeteridee/suggestie insturen.%0D%0A%0D%0AAls [beschrijf hier je rol of functie, bijv. Medewerker leverancier],%0D%0Awil ik [omschrijf hier je verbeteridee],%0D%0Azodat [omschrijf hier zo concreet mogelijk wat het verbeteridee specifiek voor jou of jouw team oplevert]"
                  className="size-fit"
                >
                  {t('ideas.new.description.button')}
                </Button>
              </div>
              <Text className="italic">
                {t('ideas.new.description.subtitle')}{' '}
              </Text>
            </Stack>
            <Stack gap="md">
              <Text
                as="h2"
                variant="h6"
                className="text-content-heading font-bold"
              >
                {t('ideas.focus_group.title')}
              </Text>
              <Stack gap="sm">
                <Text>{t('ideas.focus_group.description_part_1')}</Text>
                <Text>{t('ideas.focus_group.description_part_2')}</Text>
              </Stack>

              <Button
                as="a"
                action="secondary"
                emphasis="bold"
                href="mailto:info@partnersinenergie.nl?subject=Aanmelden klankbordgroep&body=Beste Team Partners in Energie,%0D%0A%0D%0AVia deze weg wil ik mij graag aanmelden voor de klankbordgroep.%0D%0A%0D%0ADe marktrol waarin ik werkzaam ben is [meetverantwoordelijke OF leverancier]"
              >
                {t('ideas.focus_group.button')}
              </Button>
              <Text className="italic">
                {t('ideas.focus_group.description_part_3')}{' '}
                <CopyButton
                  content="info@partnersinenergie.nl"
                  className="relative size-fit"
                >
                  <Link
                    to="mailto:info@partnersinenergie.nl?subject=Aanmelden klankbordgroep&body=Beste Team Partners in Energie,%0D%0A%0D%0AVia deze weg wil ik mij graag aanmelden voor de klankbordgroep.%0D%0A%0D%0ADe marktrol waarin ik werkzaam ben is [meetverantwoordelijke OF leverancier]"
                    className="text-action-primary-enabled"
                  >
                    info@partnersinenergie.nl
                  </Link>
                </CopyButton>
              </Text>
            </Stack>
          </Card>
        </Stack>
      </Page>
    </>
  );
};
